import { requestConfig } from "../config.js";

/**
 * Получить перечень всех улиц у населенного пункта
 *
 * @param {String} streetName
 * @param {String} cityName
 */
export async function apiFetchStreetList(streetName, cityName) {
  const response = await requestConfig.post("/api/v0/autocomplete_address/auto_street/", {
    street_part: streetName,
    cities_alias: cityName,
  });

  return response.data?.detail?.data;
}

/**
 * Получить перечень всех домов на улице
 *
 * @param {Number} streetId
 * @param {Number} houseNumber
 */
export async function apiFetchHouseList(streetId, houseNumber) {
  const response = await requestConfig.post("/api/v0/autocomplete_address/auto_house/", {
    street_id: streetId,
    house_number: houseNumber,
  });

  return response.data?.detail?.data;
}
